
export interface PublicState {
  privateLabelLogo: string,
}

export interface State extends PublicState {
  isLoading?: boolean;
  error?: any;
}

export const initialState: State = {
  privateLabelLogo: null,
};

export const getPrivateLabelLogo = (state: PublicState) => state.privateLabelLogo;
